module.exports = __webpack_public_path__ + "static/media/SunNUS_Logo_No_Year.ed853a30.png";